export const getPriceColor = shouldBidAmountBeGreen => {
  if (!shouldBidAmountBeGreen) return null;
  return {
    color: '#55b84b',
    fontWeight: 'bolder',
  };
};
